
<div class="container body-content">
  <app-header></app-header>
  <div class="container" style="margin-top:30px;">
    <router-outlet></router-outlet>
  </div>
</div>
<app-footer></app-footer>
